module.exports = __webpack_public_path__ + "img/busd.17a330b3.png";